export default (state = false, action) => {
  switch (action.type) {
    case "ENABLE_CART":
      return action.payload;
    default:
      return state;
  }
};
